const THEME_STORAGE_KEY = "robopost.theme";

const normalizeTheme = (value) => {
  if (!value) {
    return null;
  }
  const normalized = String(value).trim().toUpperCase();
  return normalized === "DARK" ? "DARK" : "LIGHT";
};

const getStoredTheme = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch (error) {
    return null;
  }
};

const storeTheme = (theme) => {
  const normalized = normalizeTheme(theme);
  if (!normalized) {
    return null;
  }
  if (typeof window === "undefined" || !window.localStorage) {
    return normalized;
  }
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, normalized);
  } catch (error) {
    return normalized;
  }
  return normalized;
};

const applyTheme = (theme) => {
  const normalized = normalizeTheme(theme);
  if (!normalized || typeof document === "undefined") {
    return null;
  }
  if (normalized === "DARK") {
    document.body.classList.add("dark-theme");
  } else {
    document.body.classList.remove("dark-theme");
  }
  return normalized;
};

const syncTheme = (theme) => {
  const normalized = normalizeTheme(theme);
  if (!normalized) {
    return null;
  }
  storeTheme(normalized);
  applyTheme(normalized);
  return normalized;
};

const initThemeFromStorage = () => {
  const storedTheme = getStoredTheme();
  if (storedTheme) {
    applyTheme(storedTheme);
  }
  return storedTheme;
};

export {
  applyTheme,
  getStoredTheme,
  initThemeFromStorage,
  normalizeTheme,
  storeTheme,
  syncTheme,
};
